import { render, staticRenderFns } from "./GridCalidad.vue?vue&type=template&id=e8b4aeb8&"
import script from "./GridCalidad.vue?vue&type=script&lang=js&"
export * from "./GridCalidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports